﻿let timelines = [];

export function initResourceCards() {
    const resourceCards = gsap.utils.toArray('.component_card');
    for (const card of resourceCards) {
        const overlay = card.querySelector('.overlay');
        const description = card.querySelector('.description');
        const chip = card.querySelector('.chip');
        const chipColor = '#faa41a';
        const boxShadow = '0px 0px 9px 0px rgba(0,0,0,0.16)';

        const tl = gsap.timeline({ paused: true });
        tl.set(overlay, { autoAlpha: 1 });
        tl.set(description, { autoAlpha: 1 });
        tl.from(overlay, { opacity: 0, duration: .2, ease: 'power1.out' });
        tl.from(description, { yPercent: '-2', opacity: 0, duration: .3, ease: 'power1.out' }, '<');
        tl.fromTo(chip, { backgroundColor: '#445664' }, { backgroundColor: chipColor, duration: .1 }, '<');
        tl.to(card, { boxShadow: boxShadow, duration: .25 }, '<')

        card.addEventListener('mouseenter', function () {
            tl.play();
        });
        card.addEventListener('mouseleave', function () {
            tl.reverse();
        })
        timelines.push(tl);
    }
    gsap.set(resourceCards, { autoAlpha: 1 });
    gsap.from(resourceCards, { opacity: 0, yPercent: 10, stagger: 0.1 })
}

export function destroyResourceCards() {
    for (const tl of timelines) {
        tl.kill();
    }
    timelines = [];
}